import React from "react";
import { purchaseTraceMeta } from "../lib/purchaseListMeta";

/** Secondary line under purchase code: date · vehicle · gate pass. */
export default function PurchaseTraceLine({ purchase, className = "" }) {
  const meta = purchaseTraceMeta(purchase);
  if (!meta) return null;
  return (
    <p className={`text-[10px] text-muted-foreground tabular break-words ${className}`}>
      {meta}
    </p>
  );
}
